import {Entity} from '../core/entity/core.base.entity';
import {Column} from '../core/entity/core.entity.column';
import {JoinColumn} from '../core/entity/core.entity.join.column';
import {EntityTable} from '../core/entity/core.entity.table.decorator';
import {Transient} from '../core/entity/core.entity.transient';
import {DbKind} from '../enum/db.kind';
import {FieldRelationKind} from '../enum/field.relation.kind';
import {FieldTypeKind} from '../enum/field.type.kind';
import {AccountEntity} from './account.entity';
import {SystemEntity} from './system.entity';
import {Observable} from 'rxjs';

@EntityTable('database', 'bb1cd44e-36a8-48d5-b5e6-413a67ecc001')
export class DbEntity extends Entity {

    @Column(FieldTypeKind.STRING)
    public dbName: string;

    @Column(FieldTypeKind.STRING)
    public provider: string;

    @Column(FieldTypeKind.LONG)
    public kind: DbKind;

    @Column(FieldTypeKind.ANY)
    public accessKey: any[];

    @JoinColumn(FieldTypeKind.GUID, AccountEntity, false, false, FieldRelationKind.BELONGS_TO, 'account')
    public accountId: string;

    @JoinColumn(FieldTypeKind.GUID, SystemEntity, false, false, FieldRelationKind.BELONGS_TO, 'system')
    public systemId: string;

    @Transient()
    public connections: any[];

    @Transient()
    public accessKey$: Observable<any>;

}
